import React, { useState, useEffect } from 'react';
import Axios from '../../Components/Axios/Axios';
import { useLocation } from 'react-router-dom';
import { Grid, Paper, Button, Rating, TextField, Alert, Collapse, Stack, FormControl, FormGroup, FormControlLabel, Checkbox, FormHelperText } from '@mui/material';
import FadeLoader from "react-spinners/FadeLoader";
import logo from '../../Images/ltc_logo.jpg';
import icon_success from '../../Images/Icons/check.png';

// Score Description
const ratingLabel = { 1: 'ອ່ອນຫຼາຍ', 2: 'ປັບປຸງ', 3: 'ດີປານກາງ', 4: 'ດີ', 5: 'ດີຫຼາຍ' };

function Survey({ refresh }) {
  // For Get Code from URL
  const location = useLocation();
  const empCode = new URLSearchParams(location.search).get('code');

  // Setup Token
  let token = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJfdXNlcm5hbWUiOiJDU19Nb2JpbGVfVG9rZW4iLCJfcGFzc3dvcmQiOiJDU01vQFF1ZXVlIzIwMjQiLCJpYXQiOjE3Mjk0OTcxMzB9.QGMCDsCNJGkz9ru8P1Y-Z9Zh-FzfdsMSVmSiyCrIO58";

  // Set Loading
  const [loading, setLoading] = useState(false);

  // Set Data for get Choice
  const [choiceData, setChoiceData] = useState([]);

  // Survey answer state
  const [rating, setRating] = useState(0);
  const [selectedChoices, setSelectedChoices] = useState([]);
  const [comment, setComment] = useState('');

  // Validation state
  const [errorRating, setErrorRating] = useState(false);
  const [errorChoice, setErrorChoice] = useState(false);
  const [errorSubmit, setErrorSubmit] = useState(false);

  // Setup lock reason when choose 1 or 2 Star
  const needReason = rating > 0 && rating <= 2;

  // for Loading Data
  const loadData = async () => {
    setLoading(true)

    try {
      await Axios.get("Customer/Survey/Choice", { headers: { Authorization: `Bearer ${token}` } }).then(res => {
        if (res.data.result_code == "200") {
          setChoiceData(res.data.choice_list);
        }
      })
    } catch (error) {
      // console.log(error)
    }

    setTimeout(() => {
      setLoading(false)
    }, 500);
  }

  useEffect(() => {
    loadData()
  }, [refresh])

  // Check Submited state
  const [checkSubmit, setCheckSubmit] = useState(false);

  // Lock rating for 1 hour after submit
  const LOCK_DURATION = 60 * 60 * 1000; 
  const lockKey = `survey_locked_${empCode}`;

  useEffect(() => {
    const lastSubmit = localStorage.getItem(lockKey);
    if (lastSubmit && Date.now() - Number(lastSubmit) < LOCK_DURATION) {
      setCheckSubmit(true);
    }
  }, [empCode]);

  // For Select Rating Star
  const ChooseRate = (event, newValue) => {
    setRating(newValue);
    setErrorRating(false);

    if (!newValue || newValue > 2) {
      setSelectedChoices([]);
      setErrorChoice(false);
    }
  };

  // For Select Reason Choice
  const ChooseChoice = (choice_id) => {
    setErrorChoice(false);
    setSelectedChoices((prev) => (
      prev.includes(choice_id)
        ? prev.filter((id) => id !== choice_id)
        : [...prev, choice_id]
    ));
  };

  // For Save Submit Survey
  const SaveSubmit = async () => {
    if (!rating) {
      setErrorRating(true);
      return;
    }

    if (needReason && selectedChoices.length === 0) {
      setErrorChoice(true);
      return;
    }

    setLoading(true);
    setErrorSubmit(false);

    // Set Survey Data
    let surData = {
      "emp_code": empCode,
      "rate_score": rating,
      "rate_comment": comment,
      "rate_choice": selectedChoices,
    }

    try {
      await Axios.post("Customer/Survey/Answer", surData, { headers: { Authorization: `Bearer ${token}` } }).then(res => {
        if (res.data.result_code == '200') {
          localStorage.setItem(lockKey, Date.now());
          setCheckSubmit(true);
        } else {
          setErrorSubmit(true);
        }
      })
    } catch (error) {
      setErrorSubmit(true);
    }

    setLoading(false);
  };

  return (
    <>
      {loading ? <>
        <div className='manage_loading'>
          <FadeLoader color={'#ED1C24'} loading={loading} size={10} />
        </div>
      </> : <>
        <Grid container className='survey_bg'>
          <Grid lg={4} sm={2} xs={12}></Grid>

          <Grid lg={4} sm={8} xs={12}>
            <Paper elevation={10} className='survey_form_paper'>
              <Grid container className='login_grid_logo'>
                <img src={logo} width='120' />
              </Grid>

              {checkSubmit ? <>
                <div className='survey_main_title'>ໃຫ້ຄະແນນພະນັກງານສໍາເລັດແລ້ວ</div>
                <Grid container className='login_grid_logo'>
                  <img src={icon_success} width='80' style={{ marginBottom: '20px' }} />
                </Grid>
                <div className='survey_sub_title'>ຂໍຂອບໃຈສໍາລັບຄໍາຕອບຂອງທ່ານ...</div>
              </> : <>
                <div className='survey_main_title'>ໃຫ້ຄະແນນພະນັກງານບໍລິການ</div>
                <div className='survey_sub_title'>ທ່ານພໍໃຈກັບການບໍລິການໃນຄັ້ງນີ້ຫຼາຍປານໃດ ?</div>

                <div className='survey_rating_box'>
                  <Rating
                    name='service-rating'
                    value={rating}
                    onChange={ChooseRate}
                    size='large'
                    className='survey_rating_star'
                  />

                  {rating > 0 && <div className='survey_rating_label'>{ratingLabel[rating]}</div>}
                </div>

                {errorRating && <>
                  <Stack sx={{ width: '100%', marginBottom: '15px' }}>
                    <Alert variant='outlined' severity='warning'>
                      <span className='survey_warning_alert'>ກະລຸນາເລືອກຄະແນນການບໍລິການ...</span>
                    </Alert>
                  </Stack>
                </>}

                <Collapse in={needReason} style={{ marginBottom: '10px' }}>
                  <hr className='survey_line_hr' />

                  <FormControl component='fieldset' error={errorChoice} fullWidth className='survey_reason_box'>
                    <div className='survey_reason_title'>
                      ກະລຸນາເລືອກສາເຫດ ເພື່ອນໍາໄປປັບປຸງໃຫ້ດີຂຶ້ນ <span className='survey_required_mark'>*</span>
                    </div>

                    <FormGroup>
                      {choiceData.map((choice) => (
                        <FormControlLabel
                          key={choice.choice_id}
                          className='survey_reason_checkbox'
                          control={
                            <Checkbox
                              checked={selectedChoices.includes(choice.choice_id)}
                              onChange={() => ChooseChoice(choice.choice_id)}
                            />
                          }
                          label={choice.choice_name}
                        />
                      ))}
                    </FormGroup>

                    {errorChoice && <FormHelperText sx={{ fontFamily: 'Noto Sans Lao', fontSize: 16 }}>ກະລຸນາເລືອກຢ່າງໜ້ອຍ 1 ລາຍການ</FormHelperText>}
                  </FormControl>

                  <hr className='survey_line_hr' />
                </Collapse>

                <div className='survey_comment_title'>ຄຳຄິດເຫັນເພີ່ມເຕີມ</div>
                <TextField
                  className='survey_comment_box'
                  placeholder='ພິມຄຳຄິດເຫັນເພີ່ມເຕີມຂອງທ່ານ...'
                  multiline
                  rows={3}
                  inputProps={{ maxLength: 255, style: { fontSize: 16 } }}
                  fullWidth
                  variant='outlined'
                  value={comment}
                  onChange={(e) => setComment(e.target.value)}
                  sx={{ '& .MuiInputBase-input::placeholder': { fontSize: 16 } }}
                />
                {errorSubmit && <>
                  <Stack sx={{ width: '100%', marginTop: '15px' }}>
                    <Alert variant='outlined' severity='error'>
                      <span className='survey_error_alert'>ບໍ່ສາມາດໃຫ້ຄະແນນໄດ້ ກະລຸນາລອງໃຫມ່ພາຍຫຼັງ...</span>
                    </Alert>
                  </Stack>
                </>}

                <Grid container className='survey_save_grid'>
                  <Button className='survey_save_button' fullWidth variant='contained' onClick={SaveSubmit}>ບັນທຶກ</Button>
                </Grid>
              </>}

            </Paper>
          </Grid>

          <Grid lg={4} sm={2} xs={12}></Grid>
        </Grid >
      </>}
    </>
  )
}

export default Survey